import React from 'react';

import { Analytics } from '@cobliteam/analytics';

const lazyWithRetries: typeof React.lazy = (importer) => {
  const retryImport = async () => {
    try {
      return await importer();
    } catch (error: any) {
      // retry 5 times with 2 second delay and backoff factor of 2 (2, 4, 8, 16, 32 seconds)
      for (let i = 0; i < 5; i++) {
        const time = 1000 * 2 ** i;
        await new Promise((resolve) => setTimeout(resolve, time));

        // Log the original error for debugging
        console.error('Import error:', error);

        // Extract URL from error message with better error handling
        let moduleUrl: URL | null = null;
        try {
          const urlMatch = error.message.match(/Failed to fetch dynamically imported module:\s*([^\s]+)/);
          if (!urlMatch?.[1]) {
            console.error('Could not extract URL from error message:', error.message);
            continue;
          }

          moduleUrl = new URL(urlMatch[1].trim());
        } catch (urlError) {
          console.error('Invalid URL in error message:', urlError);
          continue;
        }

        // Add timestamp for cache busting
        moduleUrl.searchParams.set('t', `${+new Date()}`);

        try {
          return await import(
            /* @vite-ignore */
            moduleUrl.href
          );
        } catch (e) {
          if (e instanceof Error) {
            Analytics.track('lazyWithRetries', {
              error: e.message,
              url: moduleUrl.href,
              time,
              attempt: i,
            });
          }
          console.info(`retrying import ${moduleUrl.href} in ${time}ms`);
        }
      }
      throw error;
    }
  };
  return React.lazy(retryImport);
};

export default lazyWithRetries;
